import { Spinner } from "./spinner.js";
import { SpinnerStyles, SpinnerTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Spinner component.
 *
 * @public
 */
export const definition = Spinner.compose({
    name: `${DesignSystem.prefix}-spinner`,
    template: SpinnerTemplate,
    styles: SpinnerStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=spinner.definition.js.map